import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import loadable from '@loadable/component';
import { Redirect } from 'react-router-dom';
import { FlexBox } from '@quikr/ui';
import { getCategories } from '../../gql/postad';

const PostAdSelect = loadable(() => import('../../components/PostAd/PostAdSelection'));

const BackGround = styled.div`
  background-color: ${({ theme }) => theme.colors.Neutral[500]};
`;

const PostAdWrapper = styled(FlexBox.Container)`
  background-color: #fff;
  margin-top: 56px;
  padding: 0 12px;
  @media screen and (min-width: 768px) {
    margin-top: 91px;
    max-width: 800px;
  }
`;

const PostAdSelection = () => {
  const { loading, data } = useQuery(getCategories, {
    errorPolicy: 'all'
  });

  useEffect(() => {
    if (data.postAdCategories) {
      gtag('event', 'page_view', {
        page_title: 'PAPSelectCat'
      });
    }
  }, [data]);

  if (loading) return null;
  if (!data.postAdCategories) return <Redirect to="/404Error" />;
  return (
    <BackGround>
      <PostAdWrapper>
        <PostAdSelect categories={data.postAdCategories} isMobile={data.isMobile}></PostAdSelect>
      </PostAdWrapper>
    </BackGround>
  );
};

export default PostAdSelection;
